import { cn } from '@/lib/utils'
import EventParticipantStatus from 'app/frontend/types/custom/EventParticipantStatus'

export type UserStat = {
  tooltipValue?: string
  displayValue: React.ReactNode
  sortValue: number
}

export type UserStatView = 'presence'

export type EventOverviewStatusByEventValue = {
  status: EventParticipantStatus
  priority: number
  participantId?: number
}

export type UserStatInput = {
  visibleEvents: wowaudit.EventReference[]
  statusByEvent: Map<number, EventOverviewStatusByEventValue>
  statView: UserStatView
}

export const getUserStat = (input: UserStatInput): UserStat => {
  switch (input.statView) {
    case 'presence':
      return presencePercentage(input)
    default:
      return { tooltipValue: undefined, displayValue: undefined, sortValue: 0 }
  }
}

export const useUserStat = (input: UserStatInput): UserStat =>
  getUserStat(input)

const presencePercentage = ({
  visibleEvents,
  statusByEvent,
}: UserStatInput): UserStat => {
  const relevantEvents = visibleEvents.filter(
    (event) => event.status !== 'cancelled' && !event.optional,
  )
  const totalEvents = relevantEvents.length
  const presentCount = relevantEvents.filter(
    (event) => statusByEvent.get(event.id)?.status === 'present',
  ).length
  const presenceRatio = totalEvents === 0 ? 0 : presentCount / totalEvents

  return {
    tooltipValue: `${presentCount} / ${totalEvents} present`,
    displayValue: (
      <div
        className={cn(
          presentCount === totalEvents
            ? 'text-success-foreground'
            : presentCount * 2 >= totalEvents
            ? 'text-warning-foreground'
            : 'text-destructive-foreground',
        )}
      >
        {(presenceRatio * 100).toFixed(0)}%
      </div>
    ),
    sortValue: presenceRatio,
  }
}
